var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div layout=\"column\">\n<md-input-container flex=\"auto\">\n<label translate=\"yes\">{{email.displayLabel}}</label>\n<input name=\"{{email.fieldName}}\" ng-model=\"email.value\" ng-disabled=\"email.ngDisabled\" ng-change=\"email.onChange()\" ng-required=\"email.isRequired\" ng-model-options=\"{ debounce: 500 }\" ng-pattern=\"email.validationPattern\" ng-blur=\"email.onBlur()\">\n<div ng-messages=\"email.field.$error\" role=\"alert\">\n<div ng-message=\"required\" translate=\"yes\">{{email.displayLabel}} is required.</div>\n<div ng-message=\"pattern\" translate=\"yes\">{{email.displayLabel}} is invalid.</div>\n</div>\n</md-input-container>\n</div>\n";
var id1="app/user-controls/email.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/user-controls/email.html
// module id = 577
// module chunks = 0